@if (items?.length) {
    <p-scrollPanel [style]="{ width: '100%', height: getHeight(items) }" styleClass="custombar1">
        <ul class="item-list" role="list">
            @for (it of items; track it.id) {
                <li class="item" [title]="it.nombre + ' • ' + it.estado + ' • ' + it.fecha_creacion">
                    <span class="name">{{ it.nombre }}</span>
                    <span class="amt">$ {{ it.sub_total | number:'1.2-2' }}</span>
                    <div class="meta">
                        <span class="tag-text">{{ it.estado }}</span>
                        <span class="dot">•</span>
                        <span class="tag-text">{{ it.cumplimiento_pct | number:'1.0-0' }}%</span>
                        <span class="dot">•</span>
                        <span class="tag-text"
                              [ngClass]="it.fecha_creacion | tagSem:(now$ | async)!">
                            {{ it.fecha_creacion | timeAgoAt:(now$ | async)! }}
                        </span>
                    </div>
                </li>
            }
        </ul>
    </p-scrollPanel>
} @else {
    <span class="muted">Sin trámites</span>
}
